/**
 * Labstep
 *
 * @module prosemirror/nodes/heading/commands
 * @desc Commands for heading nodes
 */

import { SLASH_TRIGGER } from 'labstep-web/constants/prosemirror';
import type { IStateDispatchProps } from 'labstep-web/prosemirror/marks/types';
import { getToken } from 'labstep-web/prosemirror/utils/selection';
import type { EditorState } from 'prosemirror-state';

/**
 * Creates a heading with the specified level
 * @param level - The heading level (1-6)
 */
export function insertHeading(level: number) {
  return (
    state: EditorState,
    dispatch: IStateDispatchProps['dispatch'],
  ) => {
    const token = getToken(state, SLASH_TRIGGER);
    if (!token) {
      return;
    }

    const { from, to } = token;

    if (!dispatch) {
      return false;
    }

    const tr = state.tr.delete(from, to);
    try {
      tr.setBlockType(from, to, state.schema.nodes.heading, {
        level,
      });
      dispatch(tr);
    } catch (e) {
      console.error('Error setting block type:', e);
      return false;
    }
    return true;
  };
}
